/**
 * @function escapeRegExp
 * @since 1.0.0
 * @hidden
 */
function escapeRegExp(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
/**
 * @function escapeHtml
 * @since 1.0.0
 * @hidden
 */
function escapeHtml(text) {
    return text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}
/**
 * @function highlightSubstring
 * @since 1.0.0
 * Échappe `text` (texte brut, ex. un titre) puis enveloppe les occurrences
 * de `term` avec des balises <mark>. Le résultat est du HTML sûr, prêt pour
 * dangerouslySetInnerHTML.
 */
export function highlightSubstring(text, term) {
    const escaped = escapeHtml(text);
    if (!term.trim())
        return escaped;
    const regex = new RegExp(`(${escapeRegExp(term.trim())})`, 'gi');
    return escaped.replace(regex, '<mark>$1</mark>');
}
/**
 * @function highlightInContainer
 * @since 1.0.0
 * Surligne les occurrences de `term` dans le contenu texte d'un conteneur
 * DOM déjà rendu (ex. un article converti depuis du Markdown), sans casser
 * le balisage HTML existant : ne parcourt que les nœuds texte via
 * TreeWalker et enveloppe les correspondances dans <mark>.
 */
export function highlightInContainer(container, term) {
    var _a;
    clearHighlights(container);
    const trimmed = term.trim();
    if (!trimmed)
        return;
    const regex = new RegExp(`(${escapeRegExp(trimmed)})`, 'gi');
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, {
        acceptNode(node) {
            if (!node.nodeValue || !regex.test(node.nodeValue)) {
                return NodeFilter.FILTER_REJECT;
            }
            regex.lastIndex = 0;
            return NodeFilter.FILTER_ACCEPT;
        }
    });
    const matches = [];
    let current = walker.nextNode();
    while (current) {
        matches.push(current);
        current = walker.nextNode();
    }
    for (const textNode of matches) {
        const value = textNode.nodeValue || '';
        const parts = value.split(regex);
        if (parts.length <= 1)
            continue;
        const fragment = document.createDocumentFragment();
        parts.forEach((part, index) => {
            if (index % 2 === 1) {
                const mark = document.createElement('mark');
                mark.textContent = part;
                fragment.appendChild(mark);
            }
            else if (part) {
                fragment.appendChild(document.createTextNode(part));
            }
        });
        (_a = textNode.parentNode) === null || _a === void 0 ? void 0 : _a.replaceChild(fragment, textNode);
    }
}
/**
 * @function clearHighlights
 * @since 1.0.0
 * Retire les <mark> précédemment injectés par highlightInContainer,
 * fusionnant leur texte dans le nœud parent.
 */
export function clearHighlights(container) {
    const marks = container.querySelectorAll('mark');
    marks.forEach((mark) => {
        const parent = mark.parentNode;
        if (!parent)
            return;
        parent.replaceChild(document.createTextNode(mark.textContent || ''), mark);
        parent.normalize();
    });
}
